// extracted by mini-css-extract-plugin
export default {"messageDataBox":"MessageDataBox__messageDataBox___iTcsd","compareBox":"MessageDataBox__compareBox___yQPyb"};